<template>
  <base-page
    :title="'Alerts'"
  >
    <template #main>
      <alert-list />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import AlertList from '@/components/Alert/AlertList.vue'

export default {
  components: {
    BasePage,
    AlertList
  },
}
</script>
